import React from 'react'
import PropTypes from 'prop-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { postNamedCommand } from '../../../../../service'
import SydButton from '../../../../commonDesign/Button'

function CompleteActivityButton ({ activityId, onCompleted, invalidateQueryKeys, children = 'Complete', ...buttonProps }) {
  const { clientId } = useAppContext()
  const queryClient = useQueryClient()

  const { mutate, isLoading, error } = useMutation({
    mutationFn: () => postNamedCommand('coreData', 'execute-redtail-domain-command', {
      command: 'modifyActivity',
      autoResolveConnection: true,
      clientId,
      request: {
        activityId,
        body: { completed: true }
      }
    }),
    onSuccess: () => {
      if (onCompleted) onCompleted()
      if (invalidateQueryKeys) {
        for (const key of invalidateQueryKeys) {
          queryClient.invalidateQueries({ queryKey: key })
        }
      }
    }
  })

  return (
    <>
      <SydButton
        {...buttonProps}
        icon='check'
        processing={isLoading}
        onClick={() => mutate()}
      >
        {children}
      </SydButton>
      {error ? (
        <div style={{ color: 'var(--color-decline-500)', fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>
          {error.message || 'Failed to complete task'}
        </div>
      ) : null}
    </>
  )
}

CompleteActivityButton.propTypes = {
  activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onCompleted: PropTypes.func,
  invalidateQueryKeys: PropTypes.arrayOf(PropTypes.array),
  children: PropTypes.node
}

export default CompleteActivityButton
